import * as React from "react";
import { Query } from "react-apollo";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import { Col } from "reactstrap";
import * as moment from "moment";

// GraphQL
import GetCompanyWorkOrders from "../../../GraphQL/Queries/GetCompanyWorkOrders";

// Presentation/UI
import Loader from "../../../Components/Loader/DotLoader";

export default class WorkOrders extends React.Component<{ companyId: string }> {
  // Organize work order chart data
  returnChartData = (data: any): Array<any> => {
    if (!data || !data.length) {
      return [];
    }

    let chartData: any = [];

    const allMonths = moment.monthsShort();

    // filter workOrders based on month it was created

    // January
    const janworkOrders = data.filter(
      (workOrder: any) =>
        moment(workOrder.createdAt).format("MMM") === allMonths[0]
    );

    const janData = {
      name: allMonths[0],
      Created: !janworkOrders.length ? 0 : janworkOrders.length,
      Completed: !janworkOrders.length
        ? 0
        : janworkOrders.filter(
            (workOrder: any) => workOrder.status === "COMPLETE"
          ).length,
      amt: janworkOrders.length
    };

    chartData = [...chartData, janData];

    // February
    const febworkOrders = data.filter(
      (workOrder: any) =>
        moment(workOrder.createdAt).format("MMM") === allMonths[1]
    );

    const febData = {
      name: allMonths[1],
      Created: !febworkOrders.length ? 0 : febworkOrders.length,
      Completed: !febworkOrders.length
        ? 0
        : febworkOrders.filter(
            (workOrder: any) => workOrder.status === "COMPLETE"
          ).length,
      amt: febworkOrders.length
    };

    chartData = [...chartData, febData];

    // March
    const marworkOrders = data.filter(
      (workOrder: any) =>
        moment(workOrder.createdAt).format("MMM") === allMonths[2]
    );

    const marData = {
      name: allMonths[2],
      Created: !marworkOrders.length ? 0 : marworkOrders.length,
      Completed: !marworkOrders.length
        ? 0
        : marworkOrders.filter(
            (workOrder: any) => workOrder.status === "COMPLETE"
          ).length,
      amt: marworkOrders.length
    };

    chartData = [...chartData, marData];

    // April
    const aprworkOrders = data.filter(
      (workOrder: any) =>
        moment(workOrder.createdAt).format("MMM") === allMonths[3]
    );

    const aprData = {
      name: allMonths[3],
      Created: !aprworkOrders.length ? 0 : aprworkOrders.length,
      Completed: !aprworkOrders.length
        ? 0
        : aprworkOrders.filter(
            (workOrder: any) => workOrder.status === "COMPLETE"
          ).length,
      amt: aprworkOrders.length
    };

    chartData = [...chartData, aprData];

    // May
    const mayworkOrders = data.filter(
      (workOrder: any) =>
        moment(workOrder.createdAt).format("MMM") === allMonths[4]
    );

    const mayData = {
      name: allMonths[4],
      Created: !mayworkOrders.length ? 0 : mayworkOrders.length,
      Completed: !mayworkOrders.length
        ? 0
        : mayworkOrders.filter(
            (workOrder: any) => workOrder.status === "COMPLETE"
          ).length,
      amt: mayworkOrders.length
    };

    chartData = [...chartData, mayData];

    // June
    const junworkOrders = data.filter(
      (workOrder: any) =>
        moment(workOrder.createdAt).format("MMM") === allMonths[5]
    );

    const junData = {
      name: allMonths[5],
      Created: !junworkOrders.length ? 0 : junworkOrders.length,
      Completed: !junworkOrders.length
        ? 0
        : junworkOrders.filter(
            (workOrder: any) => workOrder.status === "COMPLETE"
          ).length,
      amt: junworkOrders.length
    };

    chartData = [...chartData, junData];

    // July
    const julworkOrders = data.filter(
      (workOrder: any) =>
        moment(workOrder.createdAt).format("MMM") === allMonths[6]
    );

    const julData = {
      name: allMonths[6],
      Created: !julworkOrders.length ? 0 : julworkOrders.length,
      Completed: !julworkOrders.length
        ? 0
        : julworkOrders.filter(
            (workOrder: any) => workOrder.status === "COMPLETE"
          ).length,
      amt: julworkOrders.length
    };

    chartData = [...chartData, julData];

    // August
    const augworkOrders = data.filter(
      (workOrder: any) =>
        moment(workOrder.createdAt).format("MMM") === allMonths[7]
    );

    const augData = {
      name: allMonths[7],
      Created: !augworkOrders.length ? 0 : augworkOrders.length,
      Completed: !augworkOrders.length
        ? 0
        : augworkOrders.filter(
            (workOrder: any) => workOrder.status === "COMPLETE"
          ).length,
      amt: augworkOrders.length
    };

    chartData = [...chartData, augData];

    // September
    const sepworkOrders = data.filter(
      (workOrder: any) =>
        moment(workOrder.createdAt).format("MMM") === allMonths[8]
    );

    const sepData = {
      name: allMonths[8],
      Created: !sepworkOrders.length ? 0 : sepworkOrders.length,
      Completed: !sepworkOrders.length
        ? 0
        : sepworkOrders.filter(
            (workOrder: any) => workOrder.status === "COMPLETE"
          ).length,
      amt: sepworkOrders.length
    };

    chartData = [...chartData, sepData];

    // October
    const octworkOrders = data.filter(
      (workOrder: any) =>
        moment(workOrder.createdAt).format("MMM") === allMonths[9]
    );

    const octData = {
      name: allMonths[9],
      Created: !octworkOrders.length ? 0 : octworkOrders.length,
      Completed: !octworkOrders.length
        ? 0
        : octworkOrders.filter(
            (workOrder: any) => workOrder.status === "COMPLETE"
          ).length,
      amt: octworkOrders.length
    };

    chartData = [...chartData, octData];

    // November
    const novworkOrders = data.filter(
      (workOrder: any) =>
        moment(workOrder.createdAt).format("MMM") === allMonths[10]
    );

    const novData = {
      name: allMonths[10],
      Created: !novworkOrders.length ? 0 : novworkOrders.length,
      Completed: !novworkOrders.length
        ? 0
        : novworkOrders.filter(
            (workOrder: any) => workOrder.status === "COMPLETE"
          ).length,
      amt: novworkOrders.length
    };

    chartData = [...chartData, novData];

    // December
    const decworkOrders = data.filter(
      (workOrder: any) =>
        moment(workOrder.createdAt).format("MMM") === allMonths[11]
    );

    const decData = {
      name: allMonths[11],
      Created: !decworkOrders.length ? 0 : decworkOrders.length,
      Completed: !decworkOrders.length
        ? 0
        : decworkOrders.filter(
            (workOrder: any) => workOrder.status === "COMPLETE"
          ).length,
      amt: decworkOrders.length
    };

    chartData = [...chartData, decData];

    return chartData;
  };

  render() {
    const { companyId } = this.props;

    return (
      <Query query={GetCompanyWorkOrders} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the work orders</div>;
          }

          const workOrders = data.allWorkOrders;
          const chartData = this.returnChartData(workOrders);

          return (
            <Col xs={12} md={6} lg={6}>
              <ResponsiveContainer>
                <BarChart
                  width={600}
                  height={300}
                  data={chartData}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="Created" fill="#ffa366" />
                  <Bar dataKey="Completed" fill="#33cccc" />
                </BarChart>
              </ResponsiveContainer>
            </Col>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/DashboardCharts/WorkOrders.tsx